// extracted by mini-css-extract-plugin
module.exports = {"confirmation-modal__text":"confirmationmodal_confirmation-modal__text__tUNEj"};